(function () {
  // Upgrade a thumbnail URL to a large one (handles _###x and width/height params)
  function toLarge(url) {
    if (!url) return url;
    let u = url;

    // 1) ..._240x.jpg -> ..._1600x.jpg
    u = u.replace(/(_\d{2,4}x)(\.[a-z0-9]+)(\?.*)?$/i, '_1600x$2$3');

    // 2) ?width=###  &width=###  -> 1600
    u = u.replace(/([?&])width=\d+/i, '$1width=1600');

    // 3) ?height=### &height=### -> 1600 (Tepo often sets both)
    u = u.replace(/([?&])height=\d+/i, '$1height=1600');

    // 4) short params like w= / h= / s=
    u = u.replace(/([?&])(w|h|s)=\d+/gi, '$1$2=1600');

    return u;
  }

  function hydrate(root){
    // give EACH image inside .mwc-zoom its own data-zoom-src
    root.querySelectorAll('.mwc-zoom img').forEach((img) => {
      const thumb = img.currentSrc || img.src;
      const big   = toLarge(thumb);
      img.dataset.zoomSrc = big;
      img.style.cursor = 'zoom-in';
    });

    // if your swatch uses background-image tiles too, also set data-zoom-src on them
    root.querySelectorAll('.mwc-zoom [style*="background-image"]').forEach((el) => {
      const bg = getComputedStyle(el).backgroundImage.match(/url\(["']?(.*?)["']?\)/i);
      if (bg && bg[1]) el.dataset.zoomSrc = toLarge(bg[1]);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    hydrate(document);
    // keep working if Tepo re-renders options
    new MutationObserver((muts) => {
      muts.forEach((m) => {
        m.addedNodes && [...m.addedNodes].forEach((n) => n.nodeType === 1 && hydrate(n));
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
